/** Helper methods - mostly str manipulation **/
const apiBase = process.env.VUE_APP_API_BASE

const apiBaseMixin = {
    data: function() {
        return {
            apiBase: apiBase
        }
    },
    methods: {
        //take Date string, and returns it in app convention format
        //DD.MM.YYYY | h:i
        formatDate(strDate) {
            if (strDate) {
                const hasTime = strDate.includes(':')

                const date = new Date(strDate)
                const datePart = ("0" + date.getDate()).slice(-2) + "/" +
                        ("0" + (date.getMonth()+1)).slice(-2) + "/" +
                        date.getFullYear();

                let timePart = ''
                if (hasTime) {
                    timePart = ("0" + date.getHours()).slice(-2)+":"+("0" + date.getMinutes()).slice(-2);
                }

                return hasTime ? datePart + " | " + timePart : datePart
            }
            return ''
        }
    }
}

export default apiBaseMixin;
